import ExtensionCapability from '../../capability';
import { Specs } from '@doxyme/extensions-common';

const { PostInstall } = Specs;
type Constraints = Specs.PostInstall.Constraints;

/**
 * Post Install allows extensions to dispatch messages immediately after installing extension in app store.
 */
export default class PostInstallCapability extends ExtensionCapability<Constraints> {
  static readonly id = PostInstall.id;

  constructor() {
    super(PostInstall);
  }

  sendMessages(manifestId: string): void {
    const instance = this.getInstanceByManifestId(manifestId);
    const configs = this.configsBy(instance);
    for (const config of configs) {
      this.handleMessages(instance, config.messages);
    }
  }
}
